import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import { OptionalProps as AvatarWithTextProps } from 'components/AvatarWithText/AvatarWithText';
import GroupAvatar, { GroupModels, GroupPropType } from 'groups/components/GroupAvatar';
import GroupName, { GroupPropType as GroupNameGroupPropType } from 'groups/components/GroupName';

export type Props = {
  avatar?: React.ReactElement;
  group: GroupModels | (GroupPropType & GroupNameGroupPropType);
  hideCode?: boolean;
  subtextAppend?: React.ReactElement;
} & AvatarWithTextProps;

export default function GroupAvatarWithText({
  avatar,
  group,
  hideCode,
  subtext,
  subtextAppend,
  ...others
}: Props) {
  let subtextContent;

  if (subtext) {
    subtextContent = subtext;
  } else if (!hideCode) {
    const code = 'getCode' in group && group.getCode();
    subtextContent = (
      <React.Fragment>
        {code && `@${code}`}
        {subtextAppend && <React.Fragment> • {subtextAppend}</React.Fragment>}
      </React.Fragment>
    );
  }

  return (
    <AvatarWithText
      {...others}
      title={<GroupName group={group} />}
      avatar={avatar || <GroupAvatar group={group} />}
      subtext={subtextContent}
    />
  );
}
